import React, {useState} from "react";
import {
  MarketingAuthStatusEnum,
  MedicinesRequests,
  MedicinesSearchModel,
  NonSubstitutedMedicinesEnum
} from "@/app/api/medicines";
import {useNavigate} from "react-router-dom";
import {route} from "@/app/routes/AppRoutes";

interface MedicinesState {
  hasError: string | null;
  hasLoading: boolean;
  marketingAuthorizationStatus: MarketingAuthStatusEnum[];
  nonSubstitutedMedicines: NonSubstitutedMedicinesEnum[];
  filters: string[];
  medicines: any[];
  page: number
}

const useMedicines = () => {
  const navigate = useNavigate();
  const [state, setState] = useState<MedicinesState>({
    hasError: null,
    hasLoading: true,
    marketingAuthorizationStatus: [],
    nonSubstitutedMedicines: [],
    filters: [],
    medicines: [],
    page: 1,

  });

  const updateState = (updates: Partial<MedicinesState>) => {
    setState((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  const toggleAuthStatus = (status: MarketingAuthStatusEnum) => {
    updateState({
      filters: state.filters.includes(status.toString()) ? state.filters.filter((s) => s !== status) : [...state.filters, status],
    });


  };

  const toggleNonSubstitutedMedicines = (status: NonSubstitutedMedicinesEnum) => {
    updateState({
      filters: state.filters.includes(status.toString()) ? state.filters.filter((s) => s !== status) : [...state.filters, status],
    });
  };


  const cleanAllFilters = () => {
    updateState({
      filters: [],
    });
  };

  const search = async (query: string, initial = false) => {
    if (!initial && query.length <= 2) return
    const rBody: MedicinesSearchModel = {
      query,
      page: state.page
    }
    const medicines = await MedicinesRequests.getMedicines(rBody);
    updateState({medicines});
    if (initial) updateState({hasLoading: false})
  }

  const goToMedicineDetail = (id: string) => {
    navigate(route.medicineDetail + id);
  }

  return {
    state,
    updateState,
    toggleAuthStatus,
    toggleNonSubstitutedMedicines,
    cleanAllFilters,
    search,
    goToMedicineDetail
  };
};

export default useMedicines;